export interface Props {
  videoUrl: string;
  close?: () => void;
  disableAutoplay?: boolean;
  hideBtnGroup?: boolean;
  hideSkipBtn?: boolean;
  forcePlay?: boolean;
  showControls?: boolean;
  noMobile?: boolean;
  subtitles?: string;
  onStartEvent?: () => void;
  autoClose?: boolean;
  iframe?: HTMLIFrameElement;
}

export enum PlayerType {
  NOTSET,
  NONE,
  YOUTUBE,
  VIMEO,
  YOUKU,
}
